/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptInvitationRequest } from '../models/AcceptInvitationRequest';
import type { AuthResponse } from '../models/AuthResponse';
import type { Body_bulk_upload_invitations_api_v1_invitations_bulk_upload_post } from '../models/Body_bulk_upload_invitations_api_v1_invitations_bulk_upload_post';
import type { InvitationInfo } from '../models/InvitationInfo';
import type { UserInvitationRequest } from '../models/UserInvitationRequest';
import type { UserInvitationResponse } from '../models/UserInvitationResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class InvitationsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create Invitation
     * Create a new user invitation.
     *
     * This endpoint allows administrators to invite new users to the system
     * with predefined permissions and roles.
     * @param requestBody
     * @returns UserInvitationResponse Successful Response
     * @throws ApiError
     */
    public createInvitationApiV1InvitationsCreatePost(
        requestBody: UserInvitationRequest,
    ): CancelablePromise<UserInvitationResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/invitations/create',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Upload Invitations
     * Bulk upload user invitations from a CSV file.
     *
     * CSV columns (headers are case-insensitive):
     * - email
     * - first_name
     * - last_name
     * - company
     * - role: user|admin|superuser
     * - countries: pipe-separated country names (e.g., Romania|Germany)
     * - value_chains: pipe-separated IDs
     * - graph_sources: pipe-separated source_db values
     * - financial: pipe-separated country:source pairs (e.g., Romania:World Bank|Denmark:CVR)
     * - data_permissions: pipe-separated data types (e.g., admin|prodcom_view)
     * - expires_in_hours: integer (default: 168)
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    public bulkUploadInvitationsApiV1InvitationsBulkUploadPost(
        formData: Body_bulk_upload_invitations_api_v1_invitations_bulk_upload_post,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/invitations/bulk-upload',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Invitations
     * List all user invitations with pagination.
     *
     * This endpoint allows administrators to view all invitations
     * with their status and details.
     * @param skip
     * @param limit
     * @returns any Successful Response
     * @throws ApiError
     */
    public listInvitationsApiV1InvitationsListGet(
        skip?: number,
        limit: number = 100,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/invitations/list',
            query: {
                'skip': skip,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Invitation Info
     * Get invitation information by token.
     *
     * This endpoint allows users to view invitation details before accepting.
     * @param invitationToken
     * @returns InvitationInfo Successful Response
     * @throws ApiError
     */
    public getInvitationInfoApiV1InvitationsInfoInvitationTokenGet(
        invitationToken: string,
    ): CancelablePromise<InvitationInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/invitations/info/{invitation_token}',
            path: {
                'invitation_token': invitationToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Accept Invitation
     * Accept an invitation and create user account.
     *
     * This endpoint allows users to accept invitations and set up their accounts.
     * @param requestBody
     * @returns AuthResponse Successful Response
     * @throws ApiError
     */
    public acceptInvitationApiV1InvitationsAcceptPost(
        requestBody: AcceptInvitationRequest,
    ): CancelablePromise<AuthResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/invitations/accept',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Cancel Invitation
     * Cancel an invitation.
     *
     * This endpoint allows administrators to cancel pending invitations.
     * @param invitationId
     * @returns any Successful Response
     * @throws ApiError
     */
    public cancelInvitationApiV1InvitationsCancelInvitationIdDelete(
        invitationId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/invitations/cancel/{invitation_id}',
            path: {
                'invitation_id': invitationId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
